import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqData } from '../data/mock';

const FAQ = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Questions Fréquentes
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Tout ce que vous devez savoir sur JYA
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl px-6 hover:border-yellow-300 hover:shadow-lg transition-all duration-300"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-yellow-600 py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional help */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-yellow-50 border border-yellow-200 px-8 py-6 rounded-2xl">
            <p className="text-gray-800 text-lg mb-2">
              <span className="font-bold">Vous avez d'autres questions ?</span>
            </p>
            <p className="text-gray-600">
              Notre équipe est là pour vous aider. Contactez-nous via le formulaire ci-dessous.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
